import { FormattedMessage, useIntl } from 'react-intl';
import advancedMapLayersSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-advanced-map-layers.avif';
import customRoutesSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-custom-routes.avif';
import offlineMapsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-offline-maps.avif';
import routeAssistantSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-route-assistant.avif';
import trailConditionsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-trail-conditions.avif';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';
import plusIncludesSrc from './all-plus.avif';
import memberDealsSrc from './feature-thumb-member-deals.avif';

type Props = {
  isInUs: boolean;
  isRei?: boolean;
};

export default function PeakMembershipIncludes({ isInUs, isRei }: Props) {
  const intl = useIntl();

  if (isRei) {
    return (
      <UpsellFeatureList
        features={[
          {
            headline: intl.formatMessage({ defaultMessage: 'Route Assistant' }),
            subheadline: intl.formatMessage({ defaultMessage: 'Plan backpacking trips effortlessly with our built-in assistant' }),
            thumbnailImage: routeAssistantSrc.src
          },
          {
            headline: intl.formatMessage({ defaultMessage: 'Advanced Map Layers' }),
            subheadline: intl.formatMessage({ defaultMessage: 'Get detailed views of the land and terrain before you go' }),
            thumbnailImage: advancedMapLayersSrc.src
          },
          {
            headline: intl.formatMessage({ defaultMessage: 'Custom Routes' }),
            subheadline: intl.formatMessage({ defaultMessage: 'Start from scratch or customize to create your perfect adventure in-app' }),
            thumbnailImage: customRoutesSrc.src
          },
          {
            headline: intl.formatMessage({ defaultMessage: '...and AllTrails Plus benefits!' }),
            subheadline: intl.formatMessage({
              defaultMessage: 'Unlimited map downloads, real-time trail conditions, wrong-turn alerts, 3D trail previews and more!'
            }),
            thumbnailImage: plusIncludesSrc.src
          }
        ]}
        label={<FormattedMessage defaultMessage="Advanced tools for backpackers and bigger adventures" />}
      />
    );
  }

  const memberDeals = {
    headline: intl.formatMessage({ defaultMessage: 'Member Deals' }),
    subheadline: intl.formatMessage({ defaultMessage: 'Exclusive savings on apparel, outdoor accommodations, flights, and more' }),
    thumbnailImage: memberDealsSrc.src
  };

  const trailConditions = {
    headline: intl.formatMessage({ defaultMessage: 'Trail Conditions' }),
    subheadline: intl.formatMessage({ defaultMessage: 'Plan for trail-specific weather, snow depth, and more' }),
    thumbnailImage: trailConditionsSrc.src
  };

  const features = [
    {
      headline: intl.formatMessage({ defaultMessage: 'Route Assistant' }),
      subheadline: intl.formatMessage({ defaultMessage: 'Plan backpacking trips effortlessly with our built-in assistant' }),
      thumbnailImage: routeAssistantSrc.src
    },
    {
      headline: intl.formatMessage({ defaultMessage: 'Advanced Map Layers' }),
      subheadline: intl.formatMessage({ defaultMessage: 'Get detailed views of the land and terrain before you go' }),
      thumbnailImage: advancedMapLayersSrc.src
    },
    {
      headline: intl.formatMessage({ defaultMessage: 'Custom Routes' }),
      subheadline: intl.formatMessage({ defaultMessage: 'Start from scratch or customize to create your perfect adventure in the app' }),
      thumbnailImage: customRoutesSrc.src
    },
    {
      headline: intl.formatMessage({ defaultMessage: 'Offline Maps' }),
      subheadline: intl.formatMessage({ defaultMessage: 'Download maps so you always know where you are, even without cell service' }),
      thumbnailImage: offlineMapsSrc.src
    },
    isInUs ? memberDeals : trailConditions
  ];

  return <UpsellFeatureList features={features} label={<FormattedMessage defaultMessage="Peak membership includes" />} variant="compact" />;
}
